'use client';

import { useEffect } from 'react';

type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[];
};

declare const window: WindowWithDataLayer;

export const usePageTypeDataLayer = (type: string) => {
  const pageTypeDataLayer = {
    event: 'setPageType',
    pageType: type,
  };
  useEffect(() => {
    window.dataLayer?.push(pageTypeDataLayer);
  }, [type]);
};
